import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { Fragment } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Panel from 'components/Panel';
import Dropdown from 'components/Dropdown';
import Hint from 'components/Hint';
import Icon from 'components/Icon';
import TextLink from 'components/TextLink';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import Button from 'components/Button';
var MenuPopup = function MenuPopup(_ref) {
  var playlists = _ref.playlists,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = 'parent-playlist-popup-header';
  return /*#__PURE__*/React.createElement(Panel, {
    "aria-labelledby": id,
    role: "dialog"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    id: id,
    bold: true
  }, t('parent_playlist_item_panel_popup_title_colon')), /*#__PURE__*/React.createElement(Button, {
    icon: "x",
    left: "xxs",
    variant: "transparent",
    title: t('actions_close_modal'),
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Stack, {
    withDividers: true,
    spacing: "xs"
  }, playlists.map(function (playlist) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: playlist.id
    }, playlist.name);
  })));
};
var PlaylistDropdown = function PlaylistDropdown(_ref2) {
  var playlists = _ref2.playlists,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(Dropdown, {
    renderInPlace: true,
    allowTooltipClicks: true,
    content: function content(dropdown) {
      return /*#__PURE__*/React.createElement(MenuPopup, {
        playlists: playlists,
        onClose: dropdown.close
      });
    }
  }, function (dropdown) {
    return /*#__PURE__*/React.createElement(TextLink, {
      as: "button",
      ref: dropdown.ref,
      onClick: dropdown.toggle,
      bold: true,
      "aria-expanded": dropdown.isOpen ? 'true' : 'false'
    }, children, /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "chevron"
    }));
  });
};
var ParentPlaylistsInfo = function ParentPlaylistsInfo(_ref3) {
  var _ref3$parentPlaylists = _ref3.parentPlaylists,
    parentPlaylists = _ref3$parentPlaylists === void 0 ? [] : _ref3$parentPlaylists,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? 'asset' : _ref3$type;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var parentPlaylistCount = parentPlaylists.length;
  if (!parentPlaylistCount) {
    return null;
  }
  var key = type === 'playlist' ? 'parent_playlist_playlist_panel_hint_title' : 'parent_playlist_asset_panel_hint_title';
  return /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: key,
    count: parentPlaylistCount
  }, "This ".concat(type, " is in"), ' ', /*#__PURE__*/React.createElement(PlaylistDropdown, {
    playlists: parentPlaylists
  }, "count playlists")));
};
export default ParentPlaylistsInfo;